import React, { ReactNode, useEffect, useRef, useState } from 'react';
import CrossMark from 'components/Icons/CrossMark';
import useOnClickOutside from '../../hooks/useOnClickOutside';
interface DrawerProps {
  children?: ReactNode;
  className?: string;
  open: boolean;
  onClose?(): void;
  onCallEndAnimate?(): void;
  block?: boolean;
  clickable?: boolean;
  position: 'left' | 'right';
  showCrossMark?: boolean;
}

export default function Drawer({
  children,
  className,
  block,
  clickable,
  open,
  onCallEndAnimate,
  position,
  onClose,
  showCrossMark
}: DrawerProps) {
  const drawerRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = () => {
    if (onClose && !clickable) {
      onClose();
      document
        .getElementsByTagName('body')[0]
        .classList.remove('overflow-hidden-body');
    }
  };

  useOnClickOutside(drawerRef, (e) => {
    const target = e.target as HTMLElement;
    const overlayPortal = document.querySelector(
      '#overlay-portal'
    ) as HTMLDivElement;
    if (overlayPortal && overlayPortal.contains(target)) {
      return;
    }
    handleClickOutside();
  });

  useEffect(() => {
    if (open) {
      setIsOpen(open);
      document
        .getElementsByTagName('body')[0]
        .classList.add('overflow-hidden-body');
    } else {
      document
        .getElementsByTagName('body')[0]
        .classList.remove('overflow-hidden-body');
    }

    return () => document?.body?.classList?.remove('overflow-hidden-body');
  }, [open]);

  const [isOpen, setIsOpen] = useState(open);
  return open || isOpen ? (
    <div
      className={`fixed ${
        clickable ? 'flex' : ''
      } top-0 bottom-0 right-0 left-0 z-50 h-full w-full bg-black bg-opacity-30 ${
        open ? 'animate-opacityin' : 'animate-opacityout'
      }`}>
      {clickable && (
        <div
          onClick={() => {
            if (onClose) {
              onClose();
            }
          }}
          className="flex w-[calc(100%-470px)] bg-transparent xsmx:hidden"></div>
      )}
      <div
        ref={drawerRef}
        onAnimationEnd={() => {
          if (drawerRef && drawerRef.current) {
            if (position == 'left') {
              if (!drawerRef.current.className.includes('animate-fadein')) {
                setIsOpen(false);
                if (onCallEndAnimate) {
                  onCallEndAnimate();
                }
              }
            } else {
              if (
                !drawerRef.current.className.includes('animate-fadeinright')
              ) {
                setIsOpen(false);
                if (onCallEndAnimate) {
                  onCallEndAnimate();
                }
              }
            }
          }
        }}
        className={
          `relative h-full ${position === 'left' ? 'mr-auto' : 'ml-auto'} ${
            block ? 'w-full' : ''
          }` +
          ` ${
            open
              ? `${
                  position === 'left' ? 'animate-fadein' : 'animate-fadeinright'
                }`
              : `${
                  position === 'left'
                    ? 'animate-fadeout'
                    : 'animate-fadeoutright'
                }`
          } ${className ? className : ''}`
        }>
        {!!showCrossMark && (
          <span
            className="absolute right-[20px] top-[20px] z-[1] cursor-pointer"
            onClick={() => {
              if (onClose) {
                onClose();
              }
            }}>
            <CrossMark />
          </span>
        )}
        {children}
      </div>
    </div>
  ) : null;
}
